// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import { combineReducers } from 'redux';
import { get } from '../../../shared/http/request';
import values from 'lodash/values';
import queryString from 'query-string';
import moment from 'moment';
import { handleApiError } from '../../../shared/http/error';

/** **********************************
 * Manifest order groups redux bundle
 ********************************** */
// API
const BASE_URL = '/api/dashboard';

// Actions
const LOAD_MANIFEST_ORDER_GROUPS_PENDING = 'LOAD_MANIFEST_ORDER_GROUPS_PENDING';
const LOAD_MANIFEST_ORDER_GROUPS_FULFILLED = 'LOAD_MANIFEST_ORDER_GROUPS_FULFILLED';
const LOAD_MANIFEST_ORDER_GROUPS_REJECTED = 'LOAD_MANIFEST_ORDER_GROUPS_REJECTED';
const CLEAR_RFU = 'CLEAR_RFU';
const STORE_SEARCH_RFU = 'STORE_SEARCH_RFU';

// Reducers
const entities = (state = null, action) => {
    switch (action.type) {
        case LOAD_MANIFEST_ORDER_GROUPS_FULFILLED:
            const manifestOrderGroupsById = action.data.manifestOrderGroups.map(
                manifestOrderGroup => ({
                    [manifestOrderGroup.manifestOrderGroupId]: manifestOrderGroup,
                })
            );
            return Object.assign({}, state, ...manifestOrderGroupsById);
        case LOAD_MANIFEST_ORDER_GROUPS_PENDING:
        case LOAD_MANIFEST_ORDER_GROUPS_REJECTED:
        case CLEAR_RFU:
            return {};
        default:
            return state;
    }
};

const maxOrderGroups = (state = null, action) => {
    switch (action.type) {
        case LOAD_MANIFEST_ORDER_GROUPS_FULFILLED:
            return Object.assign({}, state, {
                maxOrderGroups: action.data.emcOrderGroups,
            });
        case LOAD_MANIFEST_ORDER_GROUPS_PENDING:
        case LOAD_MANIFEST_ORDER_GROUPS_REJECTED:
        case CLEAR_RFU:
            return {};
        default:
            return state;
    }
};

const maxManifestsPerOrderGroup = (state = [], action) => {
    switch (action.type) {
        case LOAD_MANIFEST_ORDER_GROUPS_FULFILLED:
            return Object.assign([], state, action.data.maxManifestsPerOrderGroup);
        case LOAD_MANIFEST_ORDER_GROUPS_PENDING:
        case LOAD_MANIFEST_ORDER_GROUPS_REJECTED:
        case CLEAR_RFU:
            return {};
        default:
            return state;
    }
};

const isFetching = (state = false, action) => {
    switch (action.type) {
        case LOAD_MANIFEST_ORDER_GROUPS_PENDING:
            return true;
        case LOAD_MANIFEST_ORDER_GROUPS_FULFILLED:
        case LOAD_MANIFEST_ORDER_GROUPS_REJECTED:
            return false;
        default:
            return state;
    }
};

const error = (state = null, action) => {
    switch (action.type) {
        case LOAD_MANIFEST_ORDER_GROUPS_REJECTED:
            return action.message;
        case LOAD_MANIFEST_ORDER_GROUPS_PENDING:
        case LOAD_MANIFEST_ORDER_GROUPS_FULFILLED:
        case CLEAR_RFU:
            return null;
        default:
            return state;
    }
};

export const INITIAL_RFU_SEARCH_FORM = {
    abnormalityStatus: 'RFU_OPEN_ABNORMALITIES',
    abnormalityType: '',
    emcCode: '',
    emcDockCode: '',
    fromDate: moment().subtract('1', 'days'),
    supplierCode: '',
    supplierName: '',
    toDate: moment().add('3', 'days'),
	showManifestNumber:'',
};

const searchRFUForm = (state = INITIAL_RFU_SEARCH_FORM, action) => {
    switch (action.type) {
        case STORE_SEARCH_RFU:
            return Object.assign({}, state, action.search);
        // case CLEAR_RFU:
        //     return Object.assign({}, state, initialSearchForm);
        default:
            return state;
    }
};

export default combineReducers({
    entities,
    error,
    isFetching,
    maxOrderGroups,
    maxManifestsPerOrderGroup,
    searchRFUForm,
});

// Selectors
export const getManifestOrderGroups = state => values(state.entities.manifestOrderGroups.entities);
// export const getManifestOrderGroups = (state) => mockData;
export const getMaxOrderGroups = state => values(state.entities.manifestOrderGroups.maxOrderGroups);
export const getMaxManifestsPerOrderGroup = state =>
    values(state.entities.manifestOrderGroups.maxManifestsPerOrderGroup);
export const getIsFetching = state => state.entities.manifestOrderGroups.isFetching;
export const getError = state => state.entities.manifestOrderGroups.error;
export const getSearchRFUForm = state => state.entities.manifestOrderGroups.searchRFUForm;

// Action Creators/Thunks
export function loadManifestOrderGroups(params = null) {
    return function(dispatch) {
        let url = `${BASE_URL}/rfu`;

        if (params) {
            url += `?${queryString.stringify(params)}`;
        }

        dispatch({ type: LOAD_MANIFEST_ORDER_GROUPS_PENDING });

        return get(url).then(
            data => dispatch({ type: LOAD_MANIFEST_ORDER_GROUPS_FULFILLED, data }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_MANIFEST_ORDER_GROUPS_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function clearRFU() {
    return function(dispatch) {
        dispatch({ type: CLEAR_RFU });
    };
}

export function storeSearch(search) {
    return function(dispatch) {
        dispatch({ type: STORE_SEARCH_RFU, search });
    };
}
